export const cardConstants = {
  CLEAR_CARDS_DATA: 'CLEAR_BACKEND_CARDS_DATA',
  GET_CARDS_SUMMARIES: 'GET_CARDS_SUMMARIES',
  STORE_CARDS: 'STORE_CARDS'
};
